import { DAYS } from "@/lib/services";

const DEFAULT = { start: "10:00", end: "18:00" };
const TIMES = Array.from({ length: 48 }, (_, i) => `${String(Math.floor(i / 2)).padStart(2, "0")}:${i % 2 ? "30" : "00"}`);

function TimeSelect({ value, onChange, testid }) {
  const opts = TIMES.includes(value) ? TIMES : [value, ...TIMES];
  return (
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
      className="rounded-lg border border-zinc-800 bg-zinc-950 px-2 py-1.5 font-mono text-sm text-zinc-100 focus:border-rose-700 focus:outline-none">
      {opts.map((t) => <option key={t} value={t}>{t}</option>)}
    </select>
  );
}

export default function ScheduleEditor({ value = [], onChange }) {
  const byDay = Object.fromEntries(value.map((s) => [s.day, s]));
  const toggle = (day) => onChange(byDay[day] ? value.filter((s) => s.day !== day) : [...value, { day, ...DEFAULT }].sort((a, b) => a.day - b.day));
  const setTime = (day, key, v) => onChange(value.map((s) => (s.day === day ? { ...s, [key]: v } : s)));

  return (
    <div data-testid="schedule-editor" className="rounded-xl border border-zinc-800 bg-zinc-900/40 divide-y divide-zinc-800">
      {DAYS.map((name, day) => {
        const slot = byDay[day];
        return (
          <div key={day} className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
            <label className="flex items-center gap-3 cursor-pointer min-w-[130px]">
              <input type="checkbox" data-testid={`schedule-day-${day}`} checked={!!slot} onChange={() => toggle(day)} className="h-4 w-4 accent-rose-600" />
              <span className={`text-sm ${slot ? "text-zinc-100 font-medium" : "text-zinc-500"}`}>{name}</span>
            </label>
            {slot ? (
              <div className="flex flex-wrap items-center gap-2">
                <TimeSelect value={slot.start} onChange={(v) => setTime(day, "start", v)} testid={`schedule-start-${day}`} />
                <span className="text-zinc-500 text-sm">tot</span>
                <TimeSelect value={slot.end} onChange={(v) => setTime(day, "end", v)} testid={`schedule-end-${day}`} />
                {slot.end <= slot.start && <span data-testid={`schedule-overnight-${day}`} className="text-[11px] text-amber-300">tot de volgende dag</span>}
              </div>
            ) : <span className="text-xs text-zinc-600">Niet beschikbaar</span>}
          </div>
        );
      })}
    </div>
  );
}
